// A plan's User Notes line, as typed on Admin > Manage Plans, may carry two
// markers: a leading **bold lead-in** and a trailing [NEW] badge.
export interface PlanFeatureLine {
    lead: string | null;
    text: string;
    isNew: boolean;
}

const NEW_MARKER = /\s*\[NEW\]\s*$/i;
const BOLD_LEAD = /^\*\*(.+?)\*\*\s*/;

export function parsePlanFeatureLine(line: string): PlanFeatureLine {
    let text = line.trim();
    const isNew = NEW_MARKER.test(text);
    if (isNew) text = text.replace(NEW_MARKER, "");
    const lead = BOLD_LEAD.exec(text);
    if (!lead) return { lead: null, text, isNew };
    return { lead: lead[1], text: text.slice(lead[0].length), isNew };
}
